// SunAnimation.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SupporterItem from './SupporterItem';
import TraditionGame from './TraditionGame';
import Modal from './Modal';
import { useLocation } from 'react-router-dom';

const SunAnimation = ({ 
  username,
  wish, 
  gauge, 
  token,
  clientUuid,
  interfaceUuid,
  onTraditionSuccess 
}) => {
  const [supporters, setSupporters] = useState([]);
  const [showTraditionGame, setShowTraditionGame] = useState(false);  // +++ 추가됨 +++
  const location = useLocation();

  useEffect(() => {
    const fetchSupporters = async () => {
      try {
        const response = await axios.get(
          `/users/${interfaceUuid}/supporters`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data.success) {
          const supporters = response.data.data.supporters;
          setSupporters(supporters);
        }
      } catch (error) {
        console.error('Error fetching supporters:', error);
      }
    };
    fetchSupporters();
  }, [username, token,location.pathname]);

  const calculateSunPosition = () => {
    const basePosition = 27;
    return basePosition + Math.log2(gauge) * 1.7;
  };
  const sunPosition = calculateSunPosition();

  // Ground에서 supporter 배치할 랜덤 좌표
  const getRandomGroundPosition = () => ({
    top: `${Math.random() * 40 + 30 }%`,
    left: `${Math.random() * 80 + 10 }%`,
  });

  const wishText = wish || 'No wish set';

  // TraditionGame이 성공적으로 끝났을 때 (도/개/걸/윷/모)
  const handleTraditionSuccess = (updatedNewYearSun) => {
    // 모달 닫기
    // setShowTraditionGame(false);
    // 상위 콜백에 전달 (예: UserSunPage / MySunPage에서 gauge 업데이트)
    if (onTraditionSuccess) {
      onTraditionSuccess(updatedNewYearSun);
    }
  };

  return (
    <div className="sun-animation-container">
      {/* Header */}
      <div className="header">
        <h3>{username} 님의 신년 해</h3>
        <p className="wish-text">"{wishText}"</p>
      </div>

      {/* Sky */}
      <img
        src="/assets/sky.png"
        alt="Sky"
        className="sky-image"
      />

      {/* Sea */}
      <div className="sea">
        <img
          src="/assets/sea.png"
          alt="Sea"
          className="sea-image"
        />
        <div className="gauge-display">
          <p>{gauge} 해돋음</p>
          <p className="sun-height-text">신년 해의 높이</p>
        </div>

        <div className="boat-container">
          <img
            src="/assets/boat.png"
            alt="Boat"
            className="boat-image"
          />

          {/* 기존 해 높이기 버튼 대신 윷놀이 버튼 추가 */}
          {/* <button
            className="raise-sun-button"       // 기존 스타일 재사용 가능
            onClick={() => setShowTraditionGame(true)} // +++ 추가됨 +++
          >
            해 높이기
          </button> */}

            <button
            className="raise-sun-button"       // 기존 스타일 재사용 가능
            onClick={() => {
              if (token) {
                setShowTraditionGame(true); // +++ 추가됨 +++
              } else {
                alert('로그인이 필요합니다.');
              }
            }}
          >
            해 높이기
          </button>


        </div>
      </div>

      {/* Ground */}
      <div className="ground" >
        <img
          src="/assets/ground.png"
          alt="Ground"
          className="ground-image"
        />

        {supporters.slice(0, 10).map((supporter, index) => (
          <SupporterItem
            key={index}
            supporter={supporter}
            getRandomGroundPosition={getRandomGroundPosition}
          />
        ))}
      </div>

      {/* Sun */}
      <img
        src="/assets/sun.png"
        alt="Sun"
        className="sun"
        style={{
          bottom: `${sunPosition}%`,
        }}
      />
      {/* TraditionGame 모달 */}
      <Modal
        isOpen={showTraditionGame}
        onClose={() => setShowTraditionGame(false)}
      >
        <TraditionGame
            token={token}
            clientUuid={clientUuid}
            interfaceUuid={interfaceUuid}
            username={username}
            onSuccess={handleTraditionSuccess}
            onClose={() => setShowTraditionGame(false)}
        />
      </Modal>
    </div>
    
  );
};

export default SunAnimation;
